import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  BasicTable,
  Breadcrumbs,
  CardComponent,
  Columns,
  CostTrend,
  DashedStandardDropdown,
  NoDataVisual,
  OverviewCard,
  PageTitleAndSubTitle,
  UtilizationSummaryBarChart,
  valueWithText,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { getSubtitle } from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/UtilizationSummaryBarChart';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import {
  formatAdmissionsCost,
  getInpatientDetails,
  getServiceProviders,
  InPatient,
  TopServiceProviders,
} from '../../core-utils/helper-utils/patientUtilizationHelper';

import { COMMON_TEXTS } from '../../core-utils/messages/CommonConstants';
import { utilizationPatientPageMessages } from '../../core-utils/messages/utilizationPatientMessages';
import properties from '../../core-utils/properties';
import { useStores } from '../../stores';
import Loader from '../../_components/molecules/Loader';
import ReportsModal from '../../_components/organisms/ReportsModal';
import { pageScrollDown } from '../SummaryPage';
import {
  ENROLLMENT_METRICS,
  PLAN_PERFORMANCE,
  // UTILIZATION_METRICS,
} from '../../core-utils/routes';
import { useNavigate } from 'react-router-dom';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import { utilizationmessages } from '../../core-utils/messages/utilizationProcedureConstants';
import {
  dropDownMenuItemsAlphabets,
  dropDownMenuItemsValues,
  handleHeaderMouseEnter,
  handleHeaderMouseLeave,
} from '../../core-utils/helper-utils/tableSortHelper';
import { CircularLoader } from '@HomaHealth/ui-component-library';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import FeatureAccessModal from '../../_components/organisms/FeatureAccessModal';
import {
  UserAccessConstants,
  checkUserAccess,
} from '../../core-utils/helper-utils/userAccess';
import { observer } from 'mobx-react';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import DateFilter from '../../_components/molecules/DateFilter';
import {
  addPrefix,
  numFormatterWithSuffix,
} from '../../core-utils/helper-utils/helper';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import componentConstants from '../../core-utils/messages/componentConstants';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';
import { getUtilizationAdmissionCohortCount } from '../../core-utils/axios/Cohort/UtilizationPatient';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';

export interface UtilizationPatientProps {}
const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '40px 0px 66px 63px',
    width: '1182px',
  },
});

const UtilizationPatient: React.FC<UtilizationPatientProps> = observer(() => {
  const { classes } = useStyles();
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;
  const messages = utilizationPatientPageMessages.PATIENT_UTILIZATION_PAGE;
  const [loading, setLoading] = useState<boolean>(false);
  const [chartLoading, setChartLoading] = useState<boolean>(false);
  const [serviceProviders, setServiceProviders] = useState<
    TopServiceProviders[]
  >([]);
  const [inPatientAdmissions, setInPatientAdmissions] = useState<InPatient>({
    data: [],
    rateOfChange: '',
  });
  const [inPatientDays, setInPatientDays] = useState<InPatient>({
    data: [],
    rateOfChange: '',
  });
  const [inPatientAvgStay, setInPatientAvgStay] = useState<InPatient>({
    data: [],
    rateOfChange: '',
  });
  const [admissionsCost, setAdmissionsCost] = useState<any>();
  const [costTrendXAxis, setCostTrendXAxis] = useState<any>();
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  //Summary cards states and api call functions

  const [totalEnrolled, setTotalEnrolled] = useState<any>('');
  const [totalCost, setTotalCost] = useState<any>('');
  const [providersLoading, setProvidersLoading] = useState(false);
  const navigate = useNavigate();
  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [openFeatureAccessModal, setOpenFeatureAccessModal] = useState(false);

  const [sortField, setSortField] = useState(utilizationmessages.mainSortField);
  const [sortOrder, setSortOrder] = useState(utilizationmessages.mainSortOrder);

  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const [selectedAdmissionFlag, setSelectedAdmissionFlag] = useState<string>(
    'Inpatient',
  );

  const {
    employerGroupStore,
    cohortDetailsStore,
    loginPageStore,
    quaterlyReportStore,
  } = useStores();

  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quaterlyReportStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const { open, openModal, closeModal, isEditMode } = useCohortModal();

  const { totalResults, memberIds, isInitializing } = useCohortOnPageLoad({
    fetchTotalResults: () =>
      getUtilizationAdmissionCohortCount(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        incurredStartDate,
        incurredEndDate,
        paidStartDate,
        paidEndDate,
        aggregationParameter,
        selectedAdmissionFlag,
      ),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
    isInternal: true,
    deps: [selectedAdmissionFlag],
  });
  const abortController = new AbortController();

  const [aiLoading, setAiLoading] = useState<boolean>(false);
  const screenName = allScreenLabel;
  const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
  const [aiSummaryData, setAiSummaryData] = useState<
    { title: string; description: string }[]
  >([]);

  //snackbar
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        messages.TITLE,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setPageNumber(value);
  };

  const handleAskAi = () => {
    setActiveAskAi(true);
    getAiSummarizedData();
  };

  // Edit duration related states and functions

  const requestBody1 = {
    ...payload,
    claim_id_list: cohortDetailsStore.claimIdList,
    member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
    max_claim_date:
      employerGroupStore?.employerGroupResponseData?.max_claim_date,
    admissionFlag: selectedAdmissionFlag,
  };
  const requestBody2 = {
    ...payload,
    claim_id_list: cohortDetailsStore.claimIdList,
    member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
    placeOfService: selectedAdmissionFlag,
    pageNumber: pageNumber - 1,
    sortField: sortField,
    sortOrder: sortOrder,
  };
  const params = {
    ...payload,
    claim_id_list: cohortDetailsStore.claimIdList,
    member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
    admissionFlag: selectedAdmissionFlag,
  };

  const recommendedTabStore = useStores().recommendedTabStore;

  const getAllCharts = async () => {
    setLoading(true);
    isPlanDatesFetched &&
      (await Promise.all([
        getInpatientDetails(
          requestBody1,
          setInPatientAdmissions,
          'Admissions',
          abortController.signal,
        ),
        getInpatientDetails(
          requestBody1,
          setInPatientDays,
          'In Patinet Days',
          abortController.signal,
        ),
        getInpatientDetails(
          requestBody1,
          setInPatientAvgStay,
          'In patinet Stay',
          abortController.signal,
        ),
        getAdmissionsCosts(params),
      ]).then(() => {
        setLoading(false);
      }));
    setLoading(false);
  };

  const getAdmissionsCosts = async (params: any) => {
    setChartLoading(true);
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.utilizationBaseUrl +
          properties.patientAdmissions,
        params,
        { signal: abortController.signal },
      )
      .then((res) => {
        if (res?.status === 200) {
          const formattedData = formatAdmissionsCost(
            res?.data?.data,
            selectedAdmissionFlag,
          );
          setAdmissionsCost(formattedData.series);
          setCostTrendXAxis(formattedData.xAxis);
          setTotalCost(
            addPrefix(
              '$',
              numFormatterWithSuffix(res?.data?.data?.total_cost, 2),
            ),
          );
          setTotalEnrolled(res?.data?.data?.total_member_count);
          setChartLoading(false);
        }
      })
      .catch((error) => {
        setChartLoading(false);
        return error;
      });
  };

  const getTopServiceProviders = async () => {
    setProvidersLoading(true);
    isPlanDatesFetched &&
      (await getServiceProviders(
        requestBody2,
        setServiceProviders,
        setTotalPages,
        abortController.signal,
      ));
    setProvidersLoading(false);
  };

  // Ask AI - Patient Utilization Summary
  const getAllServiceProvidersForSummary = async () => {
    try {
      const res = await axios.post(
        properties.aiqBaseUrl +
          properties.utilizationBaseUrl +
          properties.topServiceProviders,
        {
          ...payload,
          claim_id_list: cohortDetailsStore.claimIdList,
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
          placeOfService: selectedAdmissionFlag,
          // 🔑 important
          includeAllProviders: true,
        },
      );

      if (res?.status === 200) {
        return res?.data?.serviceProviders || [];
      }

      return [];
    } catch (err) {
      console.error('Provider summary fetch error', err);
      return [];
    }
  };

  const getAiSummarizedData = async () => {
    try {
      setAiLoading(true);

      // ✅ Clean Providers Data (avoid heavy payload)
      const allProviders = await getAllServiceProvidersForSummary();
      const topProviders = allProviders
        ?.sort((a: any, b: any) => b.totalCharge - a.totalCharge)
        ?.slice(0, 20);
      const cleanProviders = topProviders?.map((item: any) => ({
        providerName: item?.providerName,
        claims: item?.claims,
        totalCharge: item?.totalCharge,
        planPaid: item?.planPaid,
      }));

      // ✅ Clean Admission Cost Trend
      const cleanAdmissionsCost = admissionsCost?.map((item: any) => ({
        seriesname: item?.seriesname,
        data: item?.data,
      }));

      // ✅ Clean Chart Data
      const cleanAdmissions = {
        rateOfChange: inPatientAdmissions?.rateOfChange,
        data: inPatientAdmissions?.data,
      };

      const cleanDays = {
        rateOfChange: inPatientDays?.rateOfChange,
        data: inPatientDays?.data,
      };

      const cleanAvgStay = {
        rateOfChange: inPatientAvgStay?.rateOfChange,
        data: inPatientAvgStay?.data,
      };

      // ✅ API Responses grouped by titles
      const apiResponses = {
        title_1: {
          totalEnrolled,
          totalCost,
        },

        title_2: {
          admissionsCost: cleanAdmissionsCost,
          xAxis: costTrendXAxis,
        },

        title_3: cleanProviders,

        title_4: {
          inpatientAdmissions: cleanAdmissions,
          readmissionRate: cleanDays,
          avgLengthOfStay: cleanAvgStay,
        },
      };

      let resultArray = []; // ✅ default fallback

      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getAiSummary,
          {
            screenName: screenName.PATIENT_UTILIZATION,
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
            incurredStartDate,
            incurredEndDate,
            paidStartDate,
            paidEndDate,
            apiData: apiResponses,
          },
        );

        // ✅ Safe extraction
        resultArray = response?.data?.data?.data?.result || [];
        setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
      } catch (apiError) {
         
        console.error('AI Summary API failed:', apiError);
        // ✅ Optional: show user-friendly message
        handleOpenSnackBar('Failed to load summary', 'warning', 4000);
        setAiSummaryData([]);
      }
    } catch (error: any) {
      handleOpenSnackBar(error, 'error', 6000);
    } finally {
      setAiLoading(false);
    }
  };

  useEffect(() => {
    if (isInitializing) {
      return;
    }
    getAllCharts();

    return () => {
      abortController.abort();
    };
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
  ]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  useEffect(() => {
    if (isInitializing) {
      return;
    }
    getTopServiceProviders();
  }, [
    isInitializing,
    pageNumber,
    sortField,
    sortOrder,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
  ]);

  const UtilizationPatientCards = () => {
    const useStyles = makeStyles()({
      root: {
        display: 'flex',
        flexDirection: 'column',
      },
      tableHeader: {
        height: '48px',
        backgroundColor: patientAccessTheme.palette.grey[100],
        borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        '&:first-child': {
          paddingLeft: '28px',
        },
        textAlign: 'left',
      },
      tableRow: {
        height: '56px',
        padding: '0px',
        borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        '&:first-child': {
          paddingLeft: '28px',
        },
      },
      queryIconGrid: {
        padding: '10px 0px 10px 22px',
      },
      queryDataOverallGrid: {
        margin: '10px 10px 10px 0px',
        height: '44px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #DADEEF',
        width: '1176px',
        borderRadius: '4px',
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      queryDataTypography: {
        padding: '10px 10px',
        height: '44px',
        borderRight: '1px solid #DADEEF',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      queryDataGrid: {
        maxWidth: '400px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        minWidth: '60px',
      },
      editQueryGrid: {
        padding: '10px 40px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #DADEEF',
      },
      tooltip: {
        backgroundColor: patientAccessTheme.palette.grey[900],
        padding: '10px',
        fontSize: '13px',
        fontFamily: 'Inter',
        fontWeight: 400,
        lineHeight: '16px',
        color: patientAccessTheme.palette.status.white,
      },
      arrow: {
        color: patientAccessTheme.palette.grey[900],
        marginLeft: '50px',
      },
      popper: {
        marginTop: '-20px',
        marginLeft: '-20px',
      },
    });

    const { classes } = useStyles();
    const cardMessages =
      utilizationPatientPageMessages.PATIENT_UTILIZATION_PAGE
        .PATIENT_UTILIZATION_CARDS;

    const cellStyles = {
      color: patientAccessTheme.palette.text.mediumemphasis,
      fontSize: '12px',
      fontWeight: 500,
    };

    const [columnId, setColumnId] = useState<string>();

    const handleSort = (event: any, column: any, item: any) => {
      const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
      const { sortColumnName } = column;
      if (!sortColumnName) {
        return;
      }

      setSortField(sortColumnName);
      setSortOrder(sortOrder);
    };

    const memberColumns: Columns[] = [
      {
        name: 'Provider',
        align: 'left',
        cellStyles: cellStyles,
        sortColumnName: 'providerName',
        showThisColumn: true,
        DropDownMenuItems: dropDownMenuItemsAlphabets,
        width: '200px',
      },
      {
        name: 'Claims',
        align: 'center',
        cellStyles: cellStyles,
        sortColumnName: 'claims',
        showThisColumn: true,
        DropDownMenuItems: dropDownMenuItemsValues,
        width: '130px',
      },
      {
        name: 'Total Paid',
        align: 'right',
        cellStyles: cellStyles,
        sortColumnName: 'totalCharge',
        showThisColumn: true,
        DropDownMenuItems: dropDownMenuItemsValues,
        width: '160px',
      },
      {
        name: 'Plan Paid',
        align: 'right',
        cellStyles: cellStyles,
        sortColumnName: 'planPaid',
        showThisColumn: true,
        DropDownMenuItems: dropDownMenuItemsValues,
        width: '160px',
      },
    ];

    //click Here Navigation Functions -
    const pushToEnrollemntMetrics = () => {
      navigate(ENROLLMENT_METRICS);
    };
    const pushToPlanPerformance = () => {
      navigate(PLAN_PERFORMANCE);
    };

    return (
      <Grid container className={classes.root}>
        <CohortFilterBar />
        <Grid style={{ display: 'flex', marginBottom: '29px' }}>
          <Grid style={{ marginRight: '24px' }}>
            <OverviewCard
              title={cardMessages.MEMBERS}
              value={valueWithText(totalEnrolled?.toString(), '')}
              rootStyles={{
                width: '176px',
                height: '100px',
              }}
              showClickHere
              handleClickHere={pushToEnrollemntMetrics}
            />
          </Grid>

          <Grid style={{ marginRight: '24px' }}>
            <OverviewCard
              title={cardMessages.TOTAL_MEDICAL_COST}
              value={totalCost}
              rootStyles={{
                width: '276px',
                height: '100px',
              }}
              showClickHere
              handleClickHere={pushToPlanPerformance}
            />
          </Grid>
        </Grid>
        <Grid style={{ marginBottom: '28px' }}>
          <CostTrend
            datasetProp={admissionsCost}
            cardHeight="435px"
            cardWidth="1178px"
            chartWidth="1150"
            chartTitle={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  textColor={patientAccessTheme.palette.text.highemphasis}
                  fontSize="16px"
                  lineHeight="24px"
                  fontType="semiBold"
                  margin="0px 4px 0px 0px"
                >
                  {cardMessages.PATIENT_ADMISSION.TITLE(selectedAdmissionFlag)}
                </Typography>
              </div>
            }
            chartSubTitle={cardMessages.PATIENT_ADMISSION.SUB_TITLE}
            chartHeight="340"
            yAxisTitle="Cost ($)"
            xAxisTitle="Months"
            sAxisTitle="Members"
            isLoading={chartLoading}
            xAxisValues={costTrendXAxis}
          />
        </Grid>
        <Grid style={{ marginBottom: '28px' }}>
          <CardComponent
            title={cardMessages.TOP_PATIENT_PROVIDERS.TITLE(
              selectedAdmissionFlag,
            )}
            subTitle={''}
            width="1178px"
            height="492px"
            body={
              <>
                {providersLoading ? (
                  <Box
                    style={{
                      display: 'flex',
                      height: '338px',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <CircularLoader />
                  </Box>
                ) : (
                  <Grid style={{ marginTop: '15px' }}>
                    {serviceProviders.length > 0 ? (
                      <BasicTable
                        width="1136px"
                        columns={memberColumns}
                        cellHeight="54px"
                        headerCellHeight="66px"
                        cellPadding="16px 18px 16px 28px"
                        rowsData={serviceProviders}
                        columnId={columnId}
                        handleHeaderMouseEnter={(column: any) =>
                          handleHeaderMouseEnter(column, setColumnId)
                        }
                        handleHeaderMouseLeave={() =>
                          handleHeaderMouseLeave(setColumnId)
                        }
                        showOnHoverHeader={true}
                        handleMenuItem={handleSort}
                        displayType="row"
                        showPagination={true}
                        pageCount={totalPages}
                        pageNumber={pageNumber}
                        handlePagination={handlePageChange}
                      />
                    ) : (
                      <NoDataVisual height="400px" content="No Data" />
                    )}
                  </Grid>
                )}
              </>
            }
          />
        </Grid>
        <Grid style={{ display: 'flex', marginBottom: '28px' }}>
          <div style={{ marginRight: '24px' }}>
            <UtilizationSummaryBarChart
              title={cardMessages.NO_OF_ADMISSIONS.TITLE(selectedAdmissionFlag)}
              subtitle={getSubtitle(
                'Admissions',
                100,
                Math.abs(Number(inPatientAdmissions.rateOfChange)) + '%',
                Number(inPatientAdmissions.rateOfChange) > 0,
                selectedAdmissionFlag,
              )}
              xAxisLabel={cardMessages.NO_OF_ADMISSIONS.AXIS_LABELS.X_AXIS}
              yAxisLabel={cardMessages.NO_OF_ADMISSIONS.AXIS_LABELS.Y_AXIS}
              chartData={inPatientAdmissions?.data}
              chartProps={undefined}
            />
          </div>
          <div style={{ marginRight: '24px' }}>
            <UtilizationSummaryBarChart
              chartData={inPatientDays?.data}
              title={cardMessages.READMISSION_RATE.TITLE(selectedAdmissionFlag)}
              subtitle={getSubtitle(
                'Readmission Rate',
                '',
                Math.abs(Number(inPatientDays.rateOfChange)) + '%',
                Number(inPatientDays.rateOfChange) > 0,
                selectedAdmissionFlag,
              )}
              xAxisLabel={cardMessages.READMISSION_RATE.AXIS_LABELS.X_AXIS}
              yAxisLabel={cardMessages.READMISSION_RATE.AXIS_LABELS.Y_AXIS}
              chartProps={undefined}
            />
          </div>
          <UtilizationSummaryBarChart
            chartData={inPatientAvgStay?.data}
            title={cardMessages.INPATIENT_STAY.TITLE(selectedAdmissionFlag)}
            subtitle={getSubtitle(
              'Avg Length of Stay',
              100,
              Math.abs(Number(inPatientAvgStay?.rateOfChange)) + '%',
              Number(inPatientAvgStay?.rateOfChange) > 0,
              selectedAdmissionFlag,
            )}
            xAxisLabel={cardMessages.INPATIENT_STAY.AXIS_LABELS.X_AXIS}
            yAxisLabel={cardMessages.INPATIENT_STAY.AXIS_LABELS.Y_AXIS}
            chartProps={undefined}
          />
        </Grid>
      </Grid>
    );
  };

  const [loader] = useState<any>(<Loader />);
  const pathStore = useStores().pathStore;
  const getPath = () => {
    if (pathStore.path.length !== 0) {
      return pathStore.path;
    } else {
      return [];
    }
  };

  const isPageLoading = isPlanDatesLoading || loading || isInitializing;
  return (
    <>
      {isPageLoading ? (
        loader
      ) : (
        <div>
          <Grid container className={classes.root}>
            <Grid style={{ marginBottom: '19px' }}>
              <Breadcrumbs
                itemList={
                  getPath().length !== 0
                    ? getPath()
                    : [
                        [
                          'text',
                          'Medical Claim Utilization',
                          {
                            color: patientAccessTheme.palette.primary[500],
                            fontWeight: 500,
                          },
                          () => {
                            navigate(-1);
                          },
                        ],
                        [
                          'text',
                          messages.TITLE,
                          {
                            color: patientAccessTheme.palette.text.highemphasis,
                            fontWeight: 600,
                          },
                        ],
                      ]
                }
              />
            </Grid>
            <Grid
              style={{
                marginBottom: '36px',

                position: 'relative',
              }}
            >
              <PageTitleAndSubTitle
                title={
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Typography
                        fontSize="18px"
                        lineHeight="22px"
                        fontType="semiBold"
                        textColor={patientAccessTheme.palette.text.highemphasis}
                        margin="0px 8px 0px 0px"
                      >
                        {messages.TITLE + ' of'}
                      </Typography>
                      <DashedStandardDropdown
                        options={messages.ADMISSION_FLAGS}
                        displayValue={messages.ADMISSION_FLAGS}
                        value={selectedAdmissionFlag}
                        handleChange={(e) =>
                          setSelectedAdmissionFlag(e.target.value as string)
                        }
                      />
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Typography
                        fontSize="17px"
                        lineHeight="21px"
                        textColor={
                          patientAccessTheme.palette.text.mediumemphasis
                        }
                        fontType="semiBold"
                        margin="0px 8px 0px 31px"
                      >
                        {COMMON_TEXTS.FOR}
                      </Typography>
                      <DateFilter />
                    </Box>
                  </Box>
                }
                subTitle={messages.SUBTITLE}
                showDownloadButton={true}
                // downloadButtonAction={() => setOpenReportsModal(true)}
                downloadButtonAction={() => {
                  downloadPdf(
                    'utilizationPatientReport',
                    {
                      employer:
                        employerGroupStore?.employerGroupResponseData
                          ?.employer_group_name,
                      member_unique_id_list: [],
                      claim_id_list: [],
                      maxClaimDate:
                        employerGroupStore?.employerGroupResponseData
                          ?.max_claim_date,
                      ...payload,
                    },
                    handleOpenSnackBar,
                    'open',
                  );
                  handleOpenSnackBar(
                    snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                    'info',
                    6000,
                  );
                }}
                showQueryDataButton={checkUserAccess(
                  UserAccessConstants.COHORT_DETAILS,
                  loginPageStore.userResponse.role.name,
                  loginPageStore.userFeatures,
                )}
                queryButtonText={
                  cohortDetailsStore.cohortDetailsList?.length > 0 &&
                  cohortDetailsStore.cohortDetailsList[0].category !== ''
                    ? 'Edit Cohort'
                    : 'Add Cohort'
                }
                queryDataAction={() => {
                  if (
                    checkUserAccess(
                      UserAccessConstants.COHORT_DETAILS,
                      loginPageStore.userResponse.role.name,
                      loginPageStore.userFeatures,
                    )
                  ) {
                    openModal();
                  }
                }}
                showAskAi={true}
                askAiAction={handleAskAi}
              />

              <TabSelection
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={handleSelectedIndex}
                recommendationFetched={recommendationFetched}
              />
            </Grid>
            <Grid>
              {selectedTabIndex === 0 && <UtilizationPatientCards />}
              {selectedTabIndex === 1 && (
                <RecommendationsTab
                  recommendationLoading={recommendationLoading}
                  isInternalPage={true}
                />
              )}
            </Grid>
            <div id="scroll-top-element" />
          </Grid>
          {pageScrollDown('scroll-top-element')}
        </div>
      )}
      {/**
       * TODO: Update the below component with Incurred Dates and Paid Dates
       */}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <AiSummaryCard
        open={activeAskAi}
        onClose={() => {
          setActiveAskAi(false);
          setAiSummaryData([]);
        }}
        aiSummaryData={aiSummaryData}
        loading={aiLoading}
      />
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={incurredStartDate}
        endDate={incurredEndDate}
      />
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
        existingMemberUniqueIds={memberIds}
      />
      <FeatureAccessModal
        open={openFeatureAccessModal}
        handleClose={() => {
          setOpenFeatureAccessModal(false);
        }}
        access={checkUserAccess(
          UserAccessConstants.COHORT_DETAILS,
          loginPageStore.userResponse.role.name,
          loginPageStore.userFeatures,
        )}
      ></FeatureAccessModal>
    </>
  );
});

export default UtilizationPatient;
